import { useQuery } from "@tanstack/react-query";

import { shippingService } from "../services/shippingService";
import { ShippingCalculationRequest } from "../types/shipping";

interface UseShippingCalculationProps {
  category?: string;
  productId?: string;
  categories?: string[];
  retailer?: string;
  packageDimensions?: {
    size?: {
      width?: { amount: number; unit: string };
      depth?: { amount: number; unit: string };
      length?: { amount: number; unit: string };
    };
    weight?: { amount: number; unit: string };
  };
  productTitle?: string;
  enabled?: boolean;
}

export const useShippingCalculation = ({
  category,
  productId,
  retailer,
  categories,
  packageDimensions,
  productTitle,
  enabled = true,
}: UseShippingCalculationProps) => {
  const {
    data: shippingData,
    isLoading,
    error,
    refetch,
    isFetched,
  } = useQuery({
    queryKey: [
      "shipping-calculation",
      category,
      categories,
      productId,
      retailer,
      packageDimensions,
      productTitle,
    ],
    queryFn: async () => {
      if (!enabled || (!packageDimensions && !productId && !productTitle)) {
        return null;
      }

      const request: ShippingCalculationRequest = {
        category,
        categories,
        productId,
        retailer,
        packageDimensions,
        productTitle,
      };

      return await shippingService.calculateShipping(request);
    },
    enabled: enabled && (!!packageDimensions || !!productId || !!productTitle),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    shippingData,
    isLoading,
    error: error?.message || null,
    refetch,
    isFetched,
  };
};
